export default __webpack_public_path__ + "assets/images/4.b04d77.avif";